/*!
 * skrollTop 0.0.1
 * https://github.com/alconstotrigo/skrollTop.js
 * @license MIT
 *
 * Copyright (C) 2018 alconstotrigo.com - A project by Alconsto Trigo
 */
(function (root, factory) {
    if ( typeof define === 'function' && define.amd ) {
        define([], (function () {
            return factory(root, root.document);
        }));
    } else if ( typeof exports === 'object' ) {
        module.exports = factory(root, root.document);
    } else {
        root.skrollTop = factory(root, root.document);
    }
})(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this, (function (window, document) {
    'use strict';

    let g_activeAnimation;
    const self = {};

    //easeInOutCubic animation included in the library
    Math.easeInOutCubic = function (t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t*t + b;return c/2*((t-=2)*t*t + 2) + b;
    };

    self.stop = function(){
        g_activeAnimation = false;
    };

    /**
     * Simulates the animated scrollTop of jQuery. Used when css3:false or scrollBar:true or autoScrolling:false
     * http://stackoverflow.com/a/16136789/1081396
     */
    self.scrollTo = function(params) {
        const element = typeof params.element !== 'undefined' ? params.element : window;
        const to = params.to;
        const duration = typeof params.duration !== 'undefined' ? params.duration : 700;
        const callback = typeof params.callback !== 'undefined' ? params.callback : null;
        const easing = typeof params.easing !== 'undefined' ? params.easing : Math.easeInOutCubic;

        const start = (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
        const change = to - start;
        let currentTime = 0;
        const increment = 16; //same amount of milliseconds as requestAnimationFrame
        g_activeAnimation = true;

        const animateScroll = function() {
            //in case we want to stop it from other function whenever we want
            if (g_activeAnimation) {
                currentTime += increment;
                element.scrollTo(0, easing(currentTime, start, change, duration));

                if (currentTime < duration) {
                    setTimeout(animateScroll, increment);
                } else if (callback){
                    callback();
                }
            }else if (currentTime < duration && callback){
                callback();
            }
        };

        animateScroll();
    };

    return self;
}));